import { icons } from 'assets'
import { IconButton, ObjectPreview, ObjectsPopupSelector, ScrollableContainer } from 'components'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react-lite'
import React, { useEffect } from 'react'
import { PROJECT_STORE } from 'store'
import styles from './SideComponentContainer.module.scss'
import { SideComponentContainerProps } from './types'

const SideComponentContainer = (props: SideComponentContainerProps) => {
  const {
    children,
    showPopup,
    onPopupClose,
    onPopupSubmit,
    selectedProjectsList,
    setSelectedProjectsList,
    handleActionClick,
    relatedProjects,
    projectId,
    [PROJECT_STORE]: {
      getProjectByIdFromVovList,
      getRelatedVovProjects,
      vovProjectList
    }
  } = props

  useEffect(() => getRelatedVovProjects(projectId), [getRelatedVovProjects, projectId])

  const containerStyles = [styles.container]
  !children && containerStyles.push(styles.paddingTop)

  return (
    <div className={containerStyles.join(' ')}>

      {children
        ? <div>
          <ScrollableContainer className={styles.childrenContainer}>
            {children}
          </ScrollableContainer>

          <div className={styles.actionsContainer}>
            <IconButton
              icon={icons.plusCircle}
              onClick={handleActionClick}
              title='Add/Remove related project (VoV).'
            />
          </div>
        </div>
        : 'No item is selected.'
      }

      {relatedProjects.length
        ? <ScrollableContainer className={styles.projectsContainer}>
          {relatedProjects.map(({ id }) =>
            <ObjectPreview
              key={id}
              object={getProjectByIdFromVovList(id)}
              disabled
            />
          )}
        </ScrollableContainer>
        : null
      }

      {showPopup &&
        <ObjectsPopupSelector
          title='Manage Related Media'
          onClose={onPopupClose}
          onSubmit={onPopupSubmit}
          objectsList={vovProjectList}
          selectedObjectsList={selectedProjectsList}
          setSelectedList={setSelectedProjectsList}
        />}
    </div>
  )
}

export default inject(PROJECT_STORE)(observer(SideComponentContainer))
